import stockImages from '../../store/json/stock_images.json'

export default {
    data() {
        return {
            stockImages
        }
    },
    methods: {
        calculatePrice({
            last_trade_price,
            open_price
        }) {
            const price = last_trade_price === 0.0 ? open_price : last_trade_price

            return parseFloat(price).toFixed(2)
        },
        calculateDayChange({
            last_day_close_price,
            last_trade_price
        }) {
            return Math.round(last_day_close_price) - Math.round(last_trade_price)
        },
    }
}
